import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';

import { isFeatureEnabled } from '../../config/featureFlags';
import { UserContext } from '../../context/UserContext';

const FeatureGuard = ({ feature, children }) => {
  const { user } = useContext(UserContext);
  if (!isFeatureEnabled(feature, user?.client)) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default FeatureGuard;
